import { FormattedMessage } from 'react-intl'
import React from 'react'

export const ALL_RESERVE_QUEUES_END = (timeNode) => (
    <FormattedMessage
        id='reserve_select.status.delayed'
        defaultMessage='Reserves of all levels will be ready: {timeNode}'
        values={{
            timeNode,
        }}
    />
)

export const TUTORIAL_TEXT = (
    <FormattedMessage
        id='reserve_select.tutorial_text'
        defaultMessage='SELECT RESERVE{lineBreak}LEVEL'
        values={{
            lineBreak: <br/>,
        }}
    />
)



// WEBPACK FOOTER //
// ./containers/BuildingCard/components/ReserveSelect/constants.jsx